import { createFileRoute } from '@tanstack/react-router';
import { BlogDetail } from '@/app/pages/blog-detail/BlogDetail.page';

export const Route = createFileRoute('/blog/$slug')({
    component: BlogDetail,
});

